// Default new-content scaffold used when a project has no custom template.
// Supports {{publishedAt}} and {{slug}} placeholders, expanded at insertion time.
export const DEFAULT_TEMPLATE = `---
title: "新規ページ"
tags: []
publishedAt: {{publishedAt}}
description: ""
heroImage: ""
heroImageAlt: ""
# aiInstructions: "例) このページはリスト中心です。項目は必ず - で箇条書きにしてください"
---

# 新規ページ

ここから書き始めます。
`;

export function applyTemplate(
  template: string,
  vars: { slug: string; publishedAt: string },
): string {
  return template
    .replace(/\{\{\s*publishedAt\s*\}\}/g, vars.publishedAt)
    .replace(/\{\{\s*slug\s*\}\}/g, vars.slug);
}
